export default __webpack_public_path__ + "8a51a32552144c8bc15e64bebb748b86.png";